import React, { useEffect, useState } from 'react';
import { List } from 'antd';
import { MenuOutlined } from "@ant-design/icons";
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
export const SortableList = ({ contextId, loading, items, idAttribute, renderItem, footer, onSorted, size, style, disabled, preview, testid }) => {
    const [sortedItems, setSortedItems] = useState([]);
    const mouseSensor = useSensor(MouseSensor);
    const touchSensor = useSensor(TouchSensor);
    const keyboardSensor = useSensor(KeyboardSensor);
    const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor);
    useEffect(() => {
        setSortedItems(items);
    }, [items]);
    const handleDragEnd = ({ active, over }) => {
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            setSortedItems(items => {
                const itemIds = sortedItems.map((e) => e[idAttribute]);
                const activeIndex = itemIds.indexOf(active.id);
                const overIndex = itemIds.indexOf(over.id);
                const newList = arrayMove(items, activeIndex, overIndex);
                onSorted(newList);
                return newList;
            });
        }
    };
    if (preview) {
        return (React.createElement(List, { bordered: true, dataSource: sortedItems, loading: loading, footer: footer, renderItem: renderItem, rowKey: idAttribute, style: style, "data-testid": testid }));
    }
    return (React.createElement(DndContext, { onDragEnd: handleDragEnd, sensors: sensors },
        React.createElement(SortableContext, { id: contextId, items: sortedItems ? sortedItems.map((a) => a[idAttribute]) : [], strategy: verticalListSortingStrategy, disabled: disabled },
            React.createElement(List, { bordered: true, dataSource: sortedItems, loading: loading, footer: footer, size: size, renderItem: renderItem, rowKey: idAttribute, style: style, "data-testid": testid }))));
};
export const SortableListItem = ({ item, idAttribute, actions, element, title, description, avatar, disabled, onClick, flipped, testid }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging, } = useSortable({ id: item[idAttribute] });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    if (flipped) {
        return (React.createElement(List.Item, { ref: setNodeRef, style: style, actions: actions, "data-testid": testid, onClick: onClick },
            element ? element(isDragging) :
                description ?
                    React.createElement(List.Item.Meta, { title: title, description: description, avatar: avatar })
                    :
                        title,
            !disabled &&
                React.createElement(MenuOutlined, { ...listeners, ...attributes, style: { padding: 12 }, "data-testid": "drag-handle" })));
    }
    return (React.createElement(List.Item, { ref: setNodeRef, style: style, actions: actions, onClick: onClick },
        !disabled &&
            React.createElement(MenuOutlined, { ...listeners, ...attributes, style: { padding: 12 } }),
        element ? element(isDragging) :
            description ?
                React.createElement(List.Item.Meta, { title: title, description: description, avatar: avatar })
                :
                    title));
};
